import {ModbusRTUMeterForm, ModbusRTUMeterTable} from '../components/deviceDefinitions/components/ModbusRTUMeter';
import {ModbusTCPMeterForm, ModbusTCPMeterTable} from '../components/deviceDefinitions/components/ModbusTCPMeter';
import {ModbusMeterForm, ModbusMeterTable} from '../components/deviceDefinitions/components/ModbusMeter';
import {RpiGPIOForm, RpiGPIOTable} from '../components/deviceDefinitions/components/RpiGPIO';
import {DSMR5Form, DSMR5Table} from '../components/deviceDefinitions/components/DSMR5';
import {ShellyPro3EmForm, ShellyPro3EmTable} from '../components/deviceDefinitions/components/ShellyPro3EM';
import {SGrDeviceForm, SGrDeviceTable} from '../components/deviceDefinitions/components/SGrDevice';
import {DlmsCosemForm, DlmsCosemTable} from '../components/deviceDefinitions/components/DlmsCosem';

/**
 * Device registry — the single source of truth for all supported device types.
 *
 * To add a new device type:
 *   1. Create a <NewDevice>.js file with Form + Table exports.
 *   2. Add one entry here.
 *   3. Done — no other file needs to change.
 *
 * @type {Array<{
 *   type: string,
 *   label: string,
 *   CardComponent: React.ComponentType|null,
 *   FormComponent: React.ComponentType|null,
 *   isArray: boolean,
 *   featureFlag?: string,
 *   useSetDevice?: boolean,
 * }>}
 */
export const deviceRegistry = [
  {
    type: 'SmartPi',
    label: 'SmartPi',
    cardTitle: 'SmartPi',
    cardDescription: 'Built in Smart Charge Controller Measurement',
    CardComponent: null,        // SmartPi has static card content
    FormComponent: null,        // SmartPi is not editable
    isArray: false,
  },
  {
    type: 'RpiGPIO',
    label: 'Input',
    CardComponent: RpiGPIOTable,
    FormComponent: RpiGPIOForm,
    isArray: true,
  },
  {
    type: 'ModbusRTUMeter',
    label: 'Modbus RTU Meter',
    CardComponent: ModbusRTUMeterTable,
    FormComponent: ModbusRTUMeterForm,
    isArray: true,
    hidden: true, // superseded by ModbusMeter; kept for legacy config rendering
  },
  {
    type: 'ModbusTCPMeter',
    label: 'Modbus TCP Meter',
    CardComponent: ModbusTCPMeterTable,
    FormComponent: ModbusTCPMeterForm,
    isArray: true,
    hidden: true, // superseded by ModbusMeter; kept for legacy config rendering
  },
  {
    type: 'ModbusMeter',
    label: 'Modbus Meter',
    CardComponent: ModbusMeterTable,
    FormComponent: ModbusMeterForm,
    isArray: true,
    useSetDevice: true, // ModbusMeter uses setDevice (functional updates for mode switching)
  },
  {
    type: 'DSMR5',
    label: 'DSMR5',
    CardComponent: DSMR5Table,
    FormComponent: DSMR5Form,
    isArray: true,
  },
  {
    type: 'ShellyPro3EM',
    label: 'Shelly Pro 3EM',
    CardComponent: ShellyPro3EmTable,
    FormComponent: ShellyPro3EmForm,
    isArray: true,
  },
  {
    type: 'DlmsCosem',
    label: 'DLMS/COSEM Meter',
    CardComponent: DlmsCosemTable,
    FormComponent: DlmsCosemForm,
    isArray: true,
    useSetDevice: true, // DlmsCosem uses setDevice (handles boolean extendedData toggle)
  },
  {
    type: 'SGrDevice',
    label: 'Smart Grid Ready Device',
    cardTitle: 'SmartGridready',
    cardLogo: '/SGR_LOGO_MINI.svg',
    cardDescription: 'SmartGridready Product',
    CardComponent: SGrDeviceTable,
    FormComponent: SGrDeviceForm,
    isArray: true,
    featureFlag: 'sgrcontainer',
    useSetDevice: true, // SGrDevice uses setDevice instead of handleChange
  },
];

/** Quick lookup by type key. */
export const getDeviceEntry = (type) => deviceRegistry.find((d) => d.type === type) || null;

